/*
  "Maximum N per order" from an `m3`-style product tag. The quota is per PRODUCT, shared by all
  variants (2 Red + 1 Blue fills m3), counted from product_id. Nothing carries over between
  orders. Untagged products are unaffected.

  Layer 1 blocks the <form> submit (product page, sticky bar, quick view, product cards,
  bundle). Layer 2 guards /cart/add|change|update against a freshly fetched cart, covering the
  drawer, cart-batch.js and any direct API call.

  Translated strings come from window.MPO_STRINGS, set inline by snippets/max-per-order.liquid.
*/
(function () {
  if (window.__maxPerOrderInited) return;
  window.__maxPerOrderInited = true;

  var S = window.MPO_STRINGS || {};
  var SENTINEL = '2147483647';
  var COUNT_SEL = '.js-cart-item-count, .header-cart_count';

  var MPO = window.MaxPerOrder = { limits: {}, variantProduct: {} };

  function num(v) { var n = parseInt(v, 10); return isNaN(n) ? 0 : n; }
  /* Singular is a separate plural form, so it cannot come from the sentinel. */
  function text(max) { return max === 1 ? (S.one || '') : String(S.other || '').split(SENTINEL).join(max); }

  MPO.setLimit = function (productId, max) {
    productId = num(productId); max = num(max);
    if (productId && max > 0) MPO.limits[productId] = max;
  };
  MPO.mapVariants = function (productId, variantIds) {
    productId = num(productId);
    (variantIds || []).forEach(function (v) { if (num(v)) MPO.variantProduct[num(v)] = productId; });
  };

  function scanDom(root) {
    (root || document).querySelectorAll('[data-mpo-product][data-mpo-max]').forEach(function (el) {
      MPO.setLimit(el.dataset.mpoProduct, el.dataset.mpoMax);
      if (el.dataset.mpoVariants) MPO.mapVariants(el.dataset.mpoProduct, el.dataset.mpoVariants.split(','));
    });
  }

  /* ---------- cart snapshot ---------- */

  var snapshot = null;

  function absorb(cart) {
    if (cart && cart.mpo) Object.keys(cart.mpo).forEach(function (pid) { MPO.setLimit(pid, cart.mpo[pid]); });
    if (cart && cart.items) snapshot = cart;
    return cart;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(absorb)
      .catch(function () { return snapshot; });
  }

  /*
    No cart fetch on page load: common.js already requests /cart.js on every page, and a second
    one is pure waste. The snapshot is warmed on first interaction instead. Until it arrives
    layer 1 has nothing to compare against and layer 2 — which always re-fetches — does the
    blocking, costing one extra round trip on a very fast first click.

    Layer 2 only sees requests made through fetch, so it is not a backstop for a native form
    POST. That window, before this file executes at all, is covered by the inline bootstrap in
    snippets/max-per-order.liquid.
  */
  var warming = null;
  function warmSnapshot() {
    if (snapshot || warming) return warming || Promise.resolve(snapshot);
    warming = fetchCart();
    return warming;
  }
  ['pointerdown', 'keydown', 'focusin'].forEach(function (evt) {
    document.addEventListener(evt, function once() {
      ['pointerdown', 'keydown', 'focusin'].forEach(function (e2) { document.removeEventListener(e2, once, true); });
      warmSnapshot();
    }, true);
  });

  function inCart(cart, productId) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (sum, li) {
      return li.product_id === productId ? sum + li.quantity : sum;
    }, 0);
  }

  /* Mirrors max-per-order-limit.liquid: exact `m<digits>`, so m03 is ignored. */
  function limitFromTags(tags) {
    var v = 0;
    (tags || []).forEach(function (t) {
      var m = /^m(\d+)$/.exec(String(t).toLowerCase());
      if (m && String(num(m[1])) === m[1] && num(m[1]) > 0) v = num(m[1]);
    });
    return v;
  }

  /*
    Resolves a limit for a product that never declared one in the DOM (Algolia results,
    app-built forms). Cached, including the "no limit" answer.
  */
  var resolved = {};
  function resolveLimit(productId, handle) {
    if (MPO.limits[productId]) return Promise.resolve(MPO.limits[productId]);
    if (productId in resolved) return Promise.resolve(resolved[productId]);
    if (!handle) return Promise.resolve(0);
    return nativeFetch('/products/' + handle + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var limit = limitFromTags(p && p.tags);
        resolved[productId] = limit;
        if (limit) MPO.setLimit(productId, limit);
        return limit;
      })
      .catch(function () { return 0; });
  }

  function lineOf(cart, id) {
    if (!cart || !cart.items) return null;
    id = String(id);
    return cart.items.filter(function (li) {
      return li.key === id || String(li.id) === id || String(li.variant_id) === id;
    })[0] || null;
  }

  /*
    Server-rendered caps go stale when the cart changes without a reload — adding from the
    drawer while standing on the product page, for instance. Cart-line inputs are skipped
    because the cart page re-renders those sections from the server on every change.
  */
  function refreshControls() {
    document.querySelectorAll('input[data-mpo-cap][data-mpo-product]').forEach(function (input) {
      if (input.closest('cart-line-item, .js-cart-line-item')) return;
      var pid = num(input.dataset.mpoProduct), max = num(input.dataset.mpoMax);
      if (!pid || !max || !snapshot) return;
      var remaining = Math.max(0, max - inCart(snapshot, pid));
      input.dataset.mpoCap = String(remaining);
      /* No max attribute at 0, or the theme's clamp rewrites the value to 0. */
      if (remaining > 0) {
        input.setAttribute('max', String(remaining));
        if (num(input.value) > remaining) input.value = remaining;
      } else {
        input.removeAttribute('max');
      }
    });
  }

  document.addEventListener('cart-add', function () {
    fetchCart().then(function () { scanDom(); refreshControls(); });
  }, false);
  document.addEventListener('cart-change', function (e) {
    var d = e.detail;
    if (d && d.items && d.items.length && 'product_id' in d.items[0]) { absorb(d); scanDom(); refreshControls(); }
    else fetchCart().then(function () { scanDom(); refreshControls(); });
  }, false);

  /*
    The theme's + button says "Only {{ max }} pcs are available" whenever the input hits its
    `max`. That wording is about stock, so it reads as wrong when the real constraint is the
    per-order cap (a product with 20 in stock and m3 would claim only 2 are available).
    Intercept at capture phase and show the order-limit message instead. When stock is the
    tighter limit, data-mpo-cap is higher than max and the theme's own message still wins.
  */
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest && e.target.closest('quantity-input-plus');
    if (!el) return;
    var group = el.closest('quantity-input') || el.parentElement;
    var input = group && group.querySelector('input[data-mpo-cap]');
    if (!input) return;
    var cap = num(input.dataset.mpoCap);
    if (num(input.value) < cap) return;
    e.preventDefault();
    e.stopPropagation();
    notify(num(input.dataset.mpoMax), num(input.dataset.mpoProduct));
  }, true);

  /*
    Typing a quantity goes through the theme's own debounced (500ms) handler, which clamps to
    `max` and shows the same stock message. Clamp first on a shorter debounce — both are timed
    from the last keystroke, so ours always lands first and the theme's check then sees a value
    already within range and stays quiet. Debounced rather than per-keystroke so typing "10"
    is not rewritten under the cursor mid-entry.
  */
  function watchTyping(e) {
    var input = e.target;
    if (!input || !input.dataset || !input.dataset.mpoCap) return;
    clearTimeout(input.__mpoT);
    input.__mpoT = setTimeout(function () {
      var cap = num(input.dataset.mpoCap);
      if (num(input.value) > cap) {
        input.value = Math.max(1, cap);
        notify(num(input.dataset.mpoMax), num(input.dataset.mpoProduct));
      }
    }, 250);
  }
  document.addEventListener('input', watchTyping, true);
  document.addEventListener('change', watchTyping, true);

  /* ---------- messaging ---------- */

  function syncCount() {
    if (!snapshot || typeof snapshot.item_count !== 'number') return;
    document.querySelectorAll(COUNT_SEL).forEach(function (el) { el.textContent = String(snapshot.item_count); });
  }

  /*
    This file is deferred, so cart-optimistic's capture listener registers before ours and has
    already bumped the badge by the time a blocked add reaches us. Correct it from the server
    rather than from a snapshot that may not have warmed yet. Submits held by the bootstrap do
    not need this — that listener registers first and stops propagation before the bump.
  */
  function resyncCount() {
    if (snapshot) { syncCount(); return; }
    fetchCart().then(syncCount);
  }

  var ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="9"/><path d="M12 8v5"/><path d="M12 16.5v.01"/></svg>';

  function toast(msg) {
    var el = document.getElementById('mpo-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'mpo-toast';
      el.className = 'mpo-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.innerHTML = ICON + '<span></span>';
    el.querySelector('span').textContent = msg;
    clearTimeout(el.__t);
    /* next frame, so the transition runs on a freshly inserted node */
    setTimeout(function () { el.classList.add('is-open'); }, 10);
    el.__t = setTimeout(function () { el.classList.remove('is-open'); }, 4000);
  }

  function notify(max, productId) {
    var msg = text(max);
    toast(msg);
    if (!productId) return;
    document.querySelectorAll('[data-mpo-notice][data-mpo-product="' + productId + '"]').forEach(function (el) {
      var span = el.querySelector('[data-mpo-text]');
      if (span) span.textContent = msg;
      el.classList.remove('d-none');
      /* Transient like the theme's own minimum-notice — never left on screen. */
      clearTimeout(el.__mpoHide);
      el.__mpoHide = setTimeout(function () { el.classList.add('d-none'); }, 4000);
    });
  }

  /* ---------- layer 1: submit guard ---------- */

  /* Bundles mix products, so their limits sit on each line's quantity input. */
  function requested(form) {
    var want = {};
    var perLine = form.querySelectorAll('input[name="quantity"][data-mpo-product][data-mpo-max]');
    if (perLine.length) {
      perLine.forEach(function (input) {
        var pid = num(input.dataset.mpoProduct), q = num(input.value);
        MPO.setLimit(pid, input.dataset.mpoMax);
        if (input.dataset.variantId) MPO.mapVariants(pid, [input.dataset.variantId]);
        if (pid && q > 0) want[pid] = (want[pid] || 0) + q;
      });
      return want;
    }
    if (!form.dataset || !form.dataset.mpoMax) return want;
    var pid = num(form.dataset.mpoProduct);
    MPO.setLimit(pid, form.dataset.mpoMax);
    if (form.dataset.mpoVariants) MPO.mapVariants(pid, form.dataset.mpoVariants.split(','));
    var qtyInput = form.querySelector('input[name="quantity"]');
    var q = qtyInput ? num(qtyInput.value) : 1;
    if (pid && q > 0) want[pid] = q;
    return want;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add/.test(action) && !form.querySelector('[name="add"]')) return;

    var want = requested(form);
    var max = 0, product = 0;
    Object.keys(want).forEach(function (pid) {
      var limit = MPO.limits[pid];
      if (limit && inCart(snapshot, num(pid)) + want[pid] > limit) { max = limit; product = num(pid); }
    });
    if (!max) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    notify(max, product);
    resyncCount();
  }, true);

  /* ---------- layer 2: fetch guard ---------- */

  var nativeFetch = window.fetch.bind(window);

  function refuse(max, productId) {
    notify(max, productId);
    fetchCart().then(function (cart) {
      syncCount();
      if (cart) { try { document.dispatchEvent(new CustomEvent('cart-change', { detail: cart })); } catch (_) {} }
    });
    return Promise.reject({ status: 422, description: text(max), message: text(max) });
  }

  function readBody(init) {
    var body = init && init.body;
    if (!body) return null;
    if (typeof body === 'string') { try { return JSON.parse(body); } catch (_) { return null; } }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var o = {};
      body.forEach(function (v, k) { o[k] = v; });
      return o;
    }
    return null;
  }

  /*
    Post-add reconciliation, NOT a pre-add block. Only for adds whose limit could not be known
    up front (unmapped variant, JS-built form such as Algolia): the add lands, then anything
    over its limit is trimmed back down — newest line first, so lines the customer already had
    are left alone. Liquid-rendered paths never reach here; they are blocked before the request.
  */
  function reconcile(addedIds) {
    var justAdded = (addedIds || []).map(String);
    /* Trim what was just added before touching lines the customer already had. */
    function trimOrder(lines) {
      var isNew = function (li) {
        return justAdded.indexOf(String(li.variant_id)) !== -1 || justAdded.indexOf(String(li.id)) !== -1;
      };
      return lines.filter(isNew).reverse().concat(lines.filter(function (li) { return !isNew(li); }).reverse());
    }
    return fetchCart().then(function (cart) {
      if (!cart || !cart.items) return;
      var byProduct = {};
      cart.items.forEach(function (li) {
        var g = byProduct[li.product_id] || (byProduct[li.product_id] = { total: 0, lines: [], handle: li.handle });
        g.total += li.quantity;
        g.lines.push(li);
      });
      return Promise.all(Object.keys(byProduct).map(function (pid) {
        return resolveLimit(num(pid), byProduct[pid].handle).then(function (limit) {
          return limit && byProduct[pid].total > limit ? { pid: num(pid), limit: limit, g: byProduct[pid] } : null;
        });
      })).then(function (over) {
        var hit = over.filter(Boolean);
        if (!hit.length) return;
        var chain = Promise.resolve();
        hit.forEach(function (o) {
          var excess = o.g.total - o.limit;
          trimOrder(o.g.lines).forEach(function (li) {
            if (excess <= 0) return;
            var take = Math.min(excess, li.quantity);
            excess -= take;
            var qty = li.quantity - take;
            chain = chain.then(function () {
              return nativeFetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: li.key, quantity: qty })
              });
            });
          });
        });
        return chain.then(function () {
          notify(hit[0].limit, hit[0].pid);
          return fetchCart().then(function (c) {
            syncCount();
            if (c) { try { document.dispatchEvent(new CustomEvent('cart-change', { detail: c })); } catch (_) {} }
          });
        });
      });
    }).catch(function () {});
  }

  window.fetch = function (input, init) {
    var u = typeof input === 'string' ? input : (input && input.url) || '';
    var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(u);
    var isChange = /\/cart\/change(\.js)?(\?|$)/.test(u);
    var isUpdate = /\/cart\/update(\.js)?(\?|$)/.test(u);
    if (!isAdd && !isChange && !isUpdate) return nativeFetch(input, init);

    var data = readBody(init);
    if (!data) return nativeFetch(input, init);

    return fetchCart().then(function (cart) {
      var max = 0, product = 0;

      if (isAdd) {
        var want = {}, unknown = false;
        (data.items || [{ id: data.id, quantity: data.quantity }]).forEach(function (it) {
          var line = lineOf(cart, it.id);
          var pid = MPO.variantProduct[num(it.id)] || (line ? line.product_id : 0);
          var q = num(it.quantity) || 1;
          if (pid) want[pid] = (want[pid] || 0) + q;
          if (!pid || !(pid in MPO.limits)) unknown = true;
        });
        Object.keys(want).forEach(function (pid) {
          var limit = MPO.limits[pid];
          if (limit && inCart(cart, num(pid)) + want[pid] > limit) { max = limit; product = num(pid); }
        });
        if (!max && unknown) {
          var addedIds = (data.items || [{ id: data.id }]).map(function (it) { return it.id; });
          return nativeFetch(input, init).then(function (res) { reconcile(addedIds); return res; });
        }
      } else {
        /* change/update set absolute quantities, so compare resulting product totals. */
        var updates = data.updates || {};
        if (isChange) updates[data.id] = data.quantity;
        var totals = {};
        Object.keys(updates).forEach(function (id) {
          var line = lineOf(cart, id);
          var pid = line ? line.product_id : 0;
          if (!pid || !MPO.limits[pid]) return;
          if (!(pid in totals)) totals[pid] = inCart(cart, pid);
          totals[pid] += num(updates[id]) - line.quantity;
        });
        Object.keys(totals).forEach(function (pid) {
          var limit = MPO.limits[pid];
          if (limit && totals[pid] > limit) { max = limit; product = num(pid); }
        });
      }

      if (max) return refuse(max, product);
      return nativeFetch(input, init);
    });
  };

  scanDom();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scanDom(); }, { once: true });
  }

  /*
    Hand over from the inline bootstrap, which has been holding submits on capped forms since
    parse time. A held submit is replayed only once the snapshot is warm, otherwise the guard
    above would have nothing to compare against and would wave it through.
  */
  var B = window.__mpo;
  if (B && !B.ready) {
    if (B.pending && B.pending.length) warmSnapshot().then(B.release, B.release);
    else B.release();
  }
})();
